<div id="top"></div>
<div class="container-fluid p-0">

    <div class="topnav" id="myTopnav">

        <div class="container">
            <a class="navbar-brand mb-4">
                <img src="/assets/Image/logo.png" alt="" width="250" height="70">
            </a>
            <div class="nav mt-4" id="nav">
                <a id="home" (click)="topFunction()" (click)="closeNav()" class="active" title="Home">HOME</a>
                <a id="about" (click)="toAbout()" (click)="closeNav()" title="About Us"> ABOUT US</a>
                <a id="service" (click)="toService()" (click)="closeNav()" title="Our Services">SERVICES</a>

                <a id="port" (click)="toPort()" (click)="closeNav()" title="Portfolio">PORTFOLIO</a>
                <a (click)="closeNav()" routerLink="../adventure" title="Our Adventures">ADVENTURES</a>
                <a id="contact" routerLink="../contact" (click)="toContact()" (click)="closeNav()"
                    title="Contact">CONTACT</a>

                <!--<a id="images" routerLink="" class="store" (click)="topFunction()" (click)="closeNav()"
                    title="Store">Store</a>-->

                <a href="javascript:void(0);" class="icon" (click)="myFunction()" id="responsive">
                    <i class="fa fa-bars"></i>
                </a>
            </div>
        </div>
    </div>
    <!--Navbar--
    <mdb-navbar SideClass="navbar fixed-top navbar-expand-lg navbar-light" [containerInside]="false">

        <!-- Navbar brand --
        <mdb-navbar-brand><a class="navbar-brand" style="padding-left: 20px;"><img src="/assets/Image/logo.png" alt=""
                    width="250" height="70"></a></mdb-navbar-brand>

        <!-- Collapsible content --
        <links>

            <!-- Links --
            <ul class="navbar-nav ml-auto">
                <li class="nav-item ">
                    <a id="home" (click)="topFunction()" class="nav-link waves-light" mdbWavesEffect title="Home">
                        HOME
                    </a>
                </li>
                <li class="nav-item ">
                    <a id="service" (click)="toService()" class="nav-link waves-light" mdbWavesEffect title="Our Services">
                        SERVICES
                    </a>
                </li>
                <li class="nav-item">
                    <a id="about" (click)="toAbout()" class="nav-link waves-light" mdbWavesEffect title="About Us">
                        ABOUT US
                    </a>
                </li>
                <li class="nav-item">
                    <a id="port" (click)="toPort()" class="nav-link waves-light" mdbWavesEffect title="Portfolio">
                        PORTFOLIO
                    </a>
                </li>

                <li class="nav-item">
                    <a id="team" (click)="toTeam()" class="nav-link waves-light" mdbWavesEffect title="Our Team">
                        TEAM
                    </a>
                </li>
                <li class="nav-item">
                    <a routerLink="../adventure" class="nav-link waves-light" mdbWavesEffect title="Our Adventures">
                        ADVENTURES
                    </a>
                </li>
                <li class="nav-item">
                    <a id="contact" routerLink="../contact" class="nav-link waves-light" mdbWavesEffect title="Contact">
                        CONTACT
                    </a>
                </li>

            </ul>
            <!-- Links --
        </links>
        <!-- Collapsible content --

    </mdb-navbar>
    <!--/.Navbar-->

    <!--Nav Background Image-->


    <!--BG Image-->
    <div id="wrapper">
        <!--Text-->
        <h2 class="text"><b><I>Grand Travel Adventures </I></b></h2>
        <br>
        <h5><b>INNOVATIVE / BUSINESS / DEVELOPMENT</b></h5>

        <!--Button-->
        <a (click)="toAbout()"><button class="btn"> <i class="fas fa-angle-down mr-1 "></i> FIND OUT MORE</button></a>
    </div>

    <div class="bg"></div>
    <!--BG Image-->

    <!--/.Nav Background Image-->



    <!--About-->
    <div id="toAbout"></div>

    <div class="container pb-5" style="padding-top: 20px;">
        <div class="title pb-4">
            <h2 style="font-size: 40px;">ABOUT US</h2>
            <p style="font-size: 20px; color: #f79c09ce; font-family: cursive; font-size: 16px;"><i>Find out more
                    about us</i></p>
        </div>

        <!--Test width:90%;-->
        <div class="row justify-content-center" style="margin-top: 50px; text-align: center;">


            <div class="col-sm-6 pb-2">
                <img src="/assets/Image/Vision.png" alt="Avatar" class="abtImg" style="width: 90%;">
            </div>
            <div class="col-sm-6 pb-2">
                <!--Vision-->
                <div class="titled pt-4">
                    <h4 style="font-size: 30px;">VISION</h4>
                    <p style="font-size: 18px; color: #f79c09ce; font-family: cursive; "><i>Our vision is...</i></p>
                </div>
                <br>
                <p class="center">To become the best leading, innovative, reliable, and respected youth-owned
                    traveling company in
                    and around Pretoria by creating uniquely inspiring and unforgettable traveling experience.
                </p>


                <br>

            </div>
            <!--Vision-->
            <br><br>
            <!--Values-->
            <div class="col-sm-6 pb-2 pt-4">

                <br>
                <div class="titled pt-2" style="text-align: left;">
                    <h4 style="font-size: 30px;">VALUES</h4>
                    <p style="font-size: 18px; color: #f79c09ce; font-family: cursive; "><i>Our values is...</i></p>
                </div>

                <br>
                <div style="text-align: left;">
                    <mdb-icon far icon="dot-circle" class="icn mr-2"></mdb-icon> Accountability
                    <br>
                    <mdb-icon far icon="dot-circle" class="icn mr-2"></mdb-icon> Respect and integrity
                    <br>
                    <mdb-icon far icon="dot-circle" class="icn mr-2"></mdb-icon> Service excellence
                    <br>
                    <mdb-icon far icon="dot-circle" class="icn mr-2"></mdb-icon> Creativity and openness
                    <br>
                    <mdb-icon far icon="dot-circle" class="icn mr-2"></mdb-icon> Commitment and communication
                    <br>
                    <mdb-icon far icon="dot-circle" class="icn mr-2"></mdb-icon> Teamwork and cultural intelligence
                    <br>
                </div>
            </div>
            <!--Values-->


            <div class="col-sm-6 pb-2  pt-4">
                <br>
                <img src="/assets/Image/BG.png" alt="Avatar" class="abtImg" style="width: 90%;">
            </div>


            <div class="col-sm-12 pb-2 pt-5">
                <!--Mission-->
                <div style="text-align: left;">
                    <div class="titled pt-5">
                        <h4 style="font-size: 30px;">MISSION</h4>
                        <p style="font-size: 18px; color: #f79c09ce; font-family: cursive; "><i>Our mission is...</i>
                        </p>
                    </div>
                    <br>
                    <p>To become a company that creates specially responsible yet unforgettable
                        traveling experiences
                        that come with services beyond expectations.
                    </p>

                    <mdb-icon far icon="dot-circle" class="icn mr-2"></mdb-icon> Adding value to travel spend while
                    focusing
                    on customer requirements.

                    <br>
                    <mdb-icon far icon="dot-circle" class="icn mr-2"></mdb-icon> Ensuring smart and affordable
                    traveling
                    by
                    expanding service – providing stakeholder relationships.
                    <br>

                    <div *ngIf="see==false" (click)="seeMore()" class="see"><i>Read More...</i>
                    </div>
                    <div *ngIf="see==true" (click)="seeLess()">
                        <div *ngIf="see==true">


                            <mdb-icon far icon="dot-circle" class="icn mr-2"></mdb-icon> Providing our customers with
                            excellent,
                            quality services.
                            <br>
                            <mdb-icon far icon="dot-circle" class="icn mr-2"></mdb-icon> Developing better relationships
                            and
                            understanding with all our stakeholders while developing comprehensive travel and tour
                            products.


                        </div>
                        <i class="see">Read Less...</i>
                    </div>

                </div>
                <!--Mission-->


            </div>

        </div>
        <!--Test-->

    </div>

    <!--/.About-->

    <!--Services-->
    <div id="toService" class="mt-5">
        <div class="about pb-5">
            <div class="container" style="padding-top: 50px;">
                <div class="title">
                    <h2 style="font-size: 40px;" id="toService">SERVICES</h2>
                    <p style="font-size: 20px; color: #f79c09ce; font-family: cursive; "><i>Services That We Offer</i>
                    </p>
                </div>


                <div class="row justify-content-center mt-5" style="margin-top: 50px; text-align: center;">

                    <!-- Transportation-->
                    <div class="col-sm-4 pb-3">
                        <!-- Card -->
                        <div class="card">

                            <div class="icon">
                                <img src="/assets/Icons/Trans.PNG" alt="" height="150" width="150">
                            </div>

                            <h3 align="center"><b>Transportation Services</b></h3>

                            <p align="center" class="mt-2">
                                Transporting our clients to, from and around their desired destinations.
                            </p>
                        </div>
                        <!-- Card -->
                    </div>
                    <!-- Transportation-->

                    <!-- Traveling-->
                    <div class="col-sm-4 pb-3">
                        <!-- Card -->
                        <div class="card">

                            <div class="icon">
                                <img src="/assets/Icons/Travel.PNG" alt="" height="150" width="150">
                            </div>

                            <h3 align="center"><b>Traveling Agency</b></h3>

                            <p align="center" class="mt-2">
                                We are a one-stop shop for all traveller’s needs including (but not limited to…)
                                transport, accommodation, and attractions.
                            </p>
                        </div>
                        <!-- Card -->
                    </div>
                    <!-- Traveling-->

                    <!-- Tour-->
                    <div class="col-sm-4 pb-3">
                        <!-- Card -->
                        <div class="card">

                            <div class="icon">
                                <img src="/assets/Icons/Tour.png" alt="" height="150" width="150">
                            </div>

                            <h3 align="center"><b>Tour Operations</b></h3>

                            <p align="center" class="mt-2">We create holidays by combining tours and travels, preparing
                                itinerary.
                            </p>
                        </div>
                        <!-- Card -->
                    </div>
                    <!--Tour-->
                    <!-- Destination-->
                    <div align="center" style="margin-top: 30px; margin: 10px;" class="col-sm-12 pb-2">
                        <div class="icon" align="center">
                            <img src="/assets/Icons/Desti.PNG" alt="" height="150" width="150">
                        </div>


                        <h3 align="center"><b>Destination Management</b></h3>

                        <p align="center" class="mt-2">
                            Possession of extensive local knowledge, expertise, and resources, specialising in the
                            design and implementation of events, activities, tours, transportation, and program
                            logistics, while being acquainted with hotels, guest houses, BNBs, hostels, rental houses,
                            lodges, camping sites and any other places offering accommodations and also being acquainted
                            to any food/beverage establishments people may want to frequent.
                        </p>
                    </div>
                    <!-- Destination-->

                </div>
            </div>
        </div>
    </div>
    <!--/.Services-->

    <!--Portfolio-->
    <div id="toPort"></div>
    <div class="container">
        <div class="title">
            <h2 style="font-size: 40px;">PORTFOLIO</h2>
            <p style="font-size: 20px; color: #f79c09ce; font-family: cursive; font-size: 16px;"><i>Some Of Our
                    Work</i>
            </p>
        </div>

        <div class="row justify-content-center" style="margin-top: 50px; text-align: center;">

            <!-- Image-->
            <div class="col-sm-4 pb-3" *ngFor="let img of images">
                <!-- Card -->
                <div class="card">

                    <div class="view overlay">
                        <a routerLink="../adventure"><img [src]="img.img" class="img-fluid"
                                alt="Sample image with waves effect.">
                            <!--<div class="mask flex-center rgba-orange-slight">
                                <p class="white-text" style="font-size: 20px;"><b> Adventures </b></p>
                            </div>-->
                        </a>


                    </div>
                    <p class="descr">
                        <b>{{img.title}}</b><br>
                        <b>{{img.description}}</b>
                    </p>
                    <p align="center" style="color: #f79c09ce; font-family: cursive; font-size: 16px;">{{img.text}}
                    </p>



                </div>
                <!-- Card -->
            </div>
            <!-- Image-->
        </div>

    </div>
    <!--/.Portfolio-->



    <!--Team--
    <div id="toTeam"></div>
    <div class="about">
        <div class="container" style="padding-top: 50px;">
            <div class="title">
                <h2 style="font-size: 40px;">TEAM</h2>
                <p style="font-size: 20px; color: #f79c09ce; font-family: cursive; font-size: 16px;"><i>Core Team
                        Responsibilities</i></p>
            </div>

            <div class="">


            </div>
            <!--Testing--

            <div class="row justify-content-center" style="margin-top: 50px; text-align: center;">

                <!-- Vee--
                <div class="col-sm-4 pb-3" *ngFor="let t of team">
                    <!-- Card --

                    <div class="avatar " style="padding-top: 10px;"><img [src]="t.img" (click)="basicModal.show()"
                            alt="avatar mx-auto white" class="rounded-circle img-fluid" width="255" height="255">

                        <br>
                        <br>
                        <h5>{{t.name}}</h5>
                    </div>

                    <!--Popup--
                    <div mdbModal #basicModal="mdbModal" class="modal fade bottom" tabindex="-1" role="dialog"
                        aria-labelledby="myBasicModalLabel" aria-hidden="true">
                        <div class="modal-dialog modal-dialog-scrollable" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button type="button" class="close pull-right" aria-label="Close"
                                        (click)="basicModal.hide()">
                                        <span aria-hidden="true">×</span>
                                    </button>
                                    <h4 class="modal-title w-100" id="myModalLabel">{{t.name}}</h4>
                                </div>
                                <div class="modal-body">
                                    <img [src]="t.img" alt="avatar mx-auto white" class="rounded-circle img-fluid"
                                         width="255" height="255">
                                    <div style="text-align: left;">
                                        <mdb-icon far icon="dot-circle" class="icn mr-2"></mdb-icon>{{t.about}}
                                        <br>
                                        <mdb-icon far icon="dot-circle" class="icn mr-2"></mdb-icon>{{t.about2}}
                                        <br>
                                        <mdb-icon far icon="dot-circle" class="icn mr-2"></mdb-icon>{{t.about3}}
                                        <br>
                                        <mdb-icon far icon="dot-circle" class="icn mr-2" *ngIf="t.about4 != ''">
                                        </mdb-icon>{{t.about4}}
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                    <!--Popup--
                    <!--Main--

                    <!-- Card --
                </div>
                <!-- Vee--
                <!--Testing--
            </div>
        </div>
        
    </div>
    <!--/.Team-->

    <!-- Footer -->
    <footer class="page-footer font-small">

        <!-- Footer Elements -->
        <div class="container">

            <!-- Grid row-->
            <div class="row">

                <!-- Grid column -->
                <div class="col-md-12 py-5">
                    <div class="mb-5 flex-center">

                        <!-- Facebook -->
                        <a class="fb-ic" href="https://web.facebook.com/?_rdc=1&_rdr">
                            <mdb-icon fab icon="facebook" size="2x" class="white-text mr-md-5 mr-3"></mdb-icon>
                        </a>
                        <!-- Twitter -->
                        <a class="tw-ic" href="https://twitter.com/?lang=en">
                            <mdb-icon fab icon="twitter" size="2x" class="white-text mr-md-5 mr-3"></mdb-icon>
                        </a>
                        <!-- Google +-->
                        <a class="gplus-ic">
                            <mdb-icon fab fab icon="google-plus" size="2x" class="white-text mr-md-5 mr-3">
                            </mdb-icon>
                        </a>

                        <!--Instagram-->
                        <a class="ins-ic" href="https://www.instagram.com/">
                            <mdb-icon fab icon="instagram" size="2x" class="white-text mr-md-5 mr-3"></mdb-icon>
                        </a>

                    </div>
                </div>
                <!-- Grid column -->

            </div>
            <!-- Grid row-->

        </div>
        <!-- Footer Elements -->

        <!-- Copyright -->
        <div class="footer-copyright text-center py-3">© 2021 Copyright
        </div>
        <!-- Copyright -->

    </footer>
    <!-- Footer -->


    <button (click)="topFunction()" id="myBtn" title="Go to top"><i class="fas fa-arrow-up"></i></button>
</div>